const src = import.meta.ROLLUP_FILE_URL_kSHvwCjLFxLpY3FM1MyAsA;
export default {
  src,
  srcSet: src + " " + 1536 + "w",
  width: 1536,
  height: 1024,
};